import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys } from "vue"
import _imports_0 from '../assets/hanging.svg'
import _imports_1 from '../assets/stt-not-found-illustration.svg'
import _imports_2 from '../assets/no-data-illustration.svg'
import _imports_3 from '../assets/hanging-found-illustration.svg'
import _imports_4 from '../assets/scan-success-illustration.svg'
import _imports_5 from '@/app/ui/assets/svg/icon-area-scan.svg'


const _hoisted_1 = { class: "flex flex-col items-center gap-y-4" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "w-auto",
  style: {"height":"42px"},
  alt: "receipt-not-found"
}
const _hoisted_3 = {
  key: 3,
  src: _imports_1,
  class: "h-auto",
  style: {"width":"179px"},
  alt: "receipt-not-found"
}
const _hoisted_4 = {
  key: 4,
  src: _imports_2,
  class: "h-auto",
  style: {"width":"179px"},
  alt: "receipt-not-found"
}
const _hoisted_5 = {
  key: 5,
  class: "relative"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "h-auto",
  style: {"width":"179px"},
  alt: "receipt-not-found"
}, null, -1)
const _hoisted_7 = {
  class: "absolute text-white text-sm font-semibold bg-red-lp-100 px-2.5 rounded-full",
  style: {"bottom":"22px","right":"18px"}
}
const _hoisted_8 = {
  key: 6,
  src: _imports_4,
  class: "h-auto",
  style: {"width":"179px"},
  alt: "receipt-not-found"
}
const _hoisted_9 = {
  key: 7,
  class: "text-black-lp-200",
  style: {"font-size":"40px","font-weight":"800"}
}
const _hoisted_10 = {
  key: 8,
  class: "px-4 py-2 rounded-full font-bold text-lg text-white bg-red-lp-2000 w-max"
}
const _hoisted_11 = {
  key: 9,
  class: "w-full rounded-2xl border border-gray-lp-1400 p-4 flex flex-col items-center gap-y-2.5"
}
const _hoisted_12 = { class: "font-bold text-black-lp-200 text-xl" }
const _hoisted_13 = { class: "flex items-center gap-x-2 gap-y-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "w-6"
}, null, -1)
const _hoisted_15 = { class: "text-sm text-black-lp-200" }
const _hoisted_16 = { class: "flex flex-wrap items-center justify-center gap-2" }
const _hoisted_17 = { class: "w-4 h-4 rounded-full flex-shrink bg-white border-2 border-red-lp-100" }
const _hoisted_18 = { class: "w-full flex flex-col gap-y-2.5 items-center border border-gray-lp-1400 rounded-xl p-4" }
const _hoisted_19 = { class: "text-gray-lp-600 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalAreaScan = _resolveComponent("ModalAreaScan")!
  const _component_LpInput = _resolveComponent("LpInput")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_ModalAreaScan, {
      modelValue: _ctx.openConfirmArea,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.openConfirmArea = $event)),
      onConfirmArea: _ctx.onConfirmAreaPopup,
      onClose: _ctx.onCloseModal
    }, null, 8, ["modelValue", "onConfirmArea", "onClose"]),
    _createVNode("div", _hoisted_1, [
      (_ctx.sttNotFound)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            src: `${_ctx.isAccountForeign ? '../assets/stt-not-found-en.svg' : 'assets/stt-not-found.svg'}`,
            class: "w-auto",
            style: {"height":"42px"},
            alt: "receipt-not-found"
          }, null, 8, ["src"]))
        : (_ctx.sttAlreadyScan)
          ? (_openBlock(), _createBlock("img", {
              key: 1,
              src: `${_ctx.isAccountForeign ? '../assets/stt-already-scan-en.svg' : 'assets/stt-already-scan.svg'}`,
              class: "w-auto",
              style: {"height":"42px"},
              alt: "receipt-not-found"
            }, null, 8, ["src"]))
          : (_ctx.latestSttData.sttNo)
            ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                (_ctx.isHanging)
                  ? (_openBlock(), _createBlock("img", _hoisted_2))
                  : (_openBlock(), _createBlock("img", {
                      key: 1,
                      src: `${_ctx.isAccountForeign ? '../assets/success-scan-en.svg' : 'assets/success-scan.svg'}`,
                      class: "w-auto",
                      style: {"height":"42px"},
                      alt: "receipt-not-found"
                    }, null, 8, ["src"]))
              ], 64))
            : _createCommentVNode("", true),
      (_ctx.sttNotFound || _ctx.sttAlreadyScan)
        ? (_openBlock(), _createBlock("img", _hoisted_3))
        : (!_ctx.latestSttData.sttNo)
          ? (_openBlock(), _createBlock("img", _hoisted_4))
          : (_ctx.isHanging)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.latestSttData.daysHanging) + " hari ", 1)
              ]))
            : (_openBlock(), _createBlock("img", _hoisted_8)),
      (_ctx.sttNotFound || _ctx.latestSttData.sttNo)
        ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.sttNotFound || _ctx.sttAlreadyScan ? _ctx.cacheForm.sttNo : _ctx.latestSttData.sttNo), 1))
        : _createCommentVNode("", true),
      (_ctx.isHanging && _ctx.latestSttData.note && !_ctx.sttNotFound)
        ? (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(_ctx.latestSttData.note), 1))
        : _createCommentVNode("", true),
      (!_ctx.isPosAccount)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("cariStt.scan.selectLocation")), 1),
            _createVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("cariStt.scan.selectLocationDescription")), 1)
            ]),
            _createVNode("div", _hoisted_16, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.locationArea, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.name,
                  id: `location-area-${item.value}`,
                  class: ["rounded-full p-3 text-white flex items-center cursor-pointer border", {
            'bg-red-lp-100 text-white border-white': _ctx.activeLocationArea(
              item.value
            ),
            'border-gray-lp-1400 text-black-lp-200': !_ctx.activeLocationArea(
              item.value
            )
          }],
                  onClick: () => (_ctx.form.scanLocation = item.value)
                }, [
                  _createVNode("div", {
                    class: ["w-5 h-5 rounded-full flex-shrink bg-white border-2 flex items-center justify-center", {
              'border-gray-lp-1300': !_ctx.activeLocationArea(item.value),
              'border-white': _ctx.activeLocationArea(item.value)
            }]
                  }, [
                    _withDirectives(_createVNode("div", _hoisted_17, null, 512), [
                      [_vShow, _ctx.activeLocationArea(item.value)]
                    ])
                  ], 2),
                  _createVNode("span", {
                    for: item.value,
                    class: "ml-2 text-base font-semibold"
                  }, _toDisplayString(item.name), 9, ["for"])
                ], 10, ["id", "onClick"]))
              }), 128))
            ]),
            (_ctx.form.scanLocation === 'OTHERS')
              ? (_openBlock(), _createBlock(_component_LpInput, {
                  key: 0,
                  id: "scan-location-note",
                  type: "textarea",
                  maxLength: "255",
                  placeholder: _ctx.$t('cariStt.scan.othersPlaceholder'),
                  showMaxLength: "",
                  textAreaRows: 1,
                  format: _ctx.replaceNewLine,
                  modelValue: _ctx.form.scanLocationNote,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.scanLocationNote = $event))
                }, null, 8, ["placeholder", "format", "modelValue"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_18, [
        _createVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("Contoh : 99LP1234567890123/88-22-12345678")), 1),
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.sttNo = $event)),
          ref: "inputStt",
          class: ["w-full text-xl placeholder-gray-lp-600 text-center outline-none", {
          'text-black-lp-200': _ctx.sttNumber
        }],
          placeholder: _ctx.$t('Masukkan no STT atau scan barcode/QR code'),
          onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onScan && _ctx.onScan(...args)), ["enter"]))
        }, null, 42, ["placeholder"]), [
          [_vModelText, _ctx.form.sttNo]
        ])
      ])
    ])
  ], 64))
}